<template>
    <div class="mines">
        <div class="mines-banner-section headerElement">
            <div class="mines-title-container">
                <h1 class="mines-title">MINES</h1>
                <p class="mines-subtitle">Pick smart. Avoid the mines. Win big.</p>
            </div>
            <img src="@/assets/img/christmas/mineBanners.jpg" alt="Mines Banner" class="mines-banner" />
        </div>
        <div class="mines-container">
            <MinesControls class="mines-controls" />
            <MinesGame class="mines-game" />
        </div>
        <Bets />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Bets from '@/components/bets/Bets';
    import MinesControls from '@/components/mines/MinesControls';
    import MinesGame from '@/components/mines/MinesGame';
    import Payment from '@/components/Payment';

    export default {
        name: 'Mines',
        metaInfo: {
            title: 'Mines'
        },
        components: {
            Bets,
            MinesControls,
            MinesGame,
            Payment
        },
        methods: {
            ...mapActions([
                'socketConnectMines', 
                'socketDisconnectMines'
            ])
        },
        created() {
            this.socketConnectMines();
        },
        beforeRouteLeave(to, from, next) {
            this.socketDisconnectMines();
            next();
        }
    }
</script>

<style scoped>
    .mines {
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 100vh;
        box-sizing: border-box;
    }

    .mines-banner-section {
        width: 100%;
        max-width: 1400px;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 100px;
        box-sizing: border-box;
    }

    .mines-title-container {
        position: absolute;
        left: 100px;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: baseline;
        gap: 20px;
        flex-wrap: nowrap;
        margin: 90px 0 0 45px;
    }

    .mines-title {
        font-family: 'Anton SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 64px;
        line-height: 69px;
        letter-spacing: 0%;
        color: var(--gradient-txt-yellow);
        background: var(--gradient-txt-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .mines-subtitle {
        font-family: 'Anton', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #ffffff;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .mines-banner {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        position: relative;
        z-index: 1;
    }

    .mines .mines-container {
        width: 100%;
        max-width: 1000px;
        display: flex;
        margin: 0 70px;
        padding: 0 var(--spacing-lg);
        position: relative;
        z-index: 1;
        box-sizing: border-box;
    }

    /* Same layout as homepage: wrapper only adds vertical spacing; Payment uses its own margin/padding */
    .mines-payment-content {
        width: 100%;
        margin: 40px 0 0 0;
        position: relative;
        z-index: 1;
    }


    @media only screen and (max-width: 1150px) {
        .mines {
            padding: 25px 10px 45px 10px;
        }

        .mines-banner-section {
            margin-bottom: 15px;
            padding: 0 var(--spacing-md);
        }

        .mines-title-container {
            left: var(--spacing-md);
            gap: 15px;
        }

        .mines-title {
            font-size: 48px;
            line-height: 52px;
        }

        .mines-subtitle {
            font-size: 18px;
        }

        .mines .mines-container {
            width: 100%;
            margin-top: 45px;
            padding: 0;
        }

        .mines-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 850px) {
        .mines-banner-section {
            padding: 0 var(--spacing-sm);
        }

        .mines-title-container {
            left: var(--spacing-sm);
            gap: 12px;
            margin: 30px 0 0 5px;
        }

        .mines-title {
            font-size: 36px;
            line-height: 40px;
        }

        .mines-subtitle {
            font-size: 16px;
        }

        .mines-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 480px) {
        .mines-banner-section {
            padding: 0 var(--spacing-xs);
        }

        .mines-title-container {
            left: var(--spacing-xs);
            gap: 10px;
            margin: 30px 0 0 5px;
        }

        .mines-title {
            font-size: 28px;
            line-height: 32px;
        }

        .mines-subtitle {
            font-size: 14px;
        }

        .mines-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 950px) {
        .mines {
            padding: 25px 10px 443px 10px;
        }
    }

    @media only screen and (max-width: 850px) {
        .mines-banner-section.headerElement {
            display: none;
        }

        /* Mobile: swap positions – MinesGame first (top), MinesControls second (below) */
        .mines .mines-container {
            flex-direction: column;
            margin-top: 50px;
            gap: 20px;
        }

        .mines .mines-container .mines-game {
            order: 0;
        }

        .mines .mines-container .mines-controls {
            order: 1;
        }
    }

    @media only screen and (max-width: 480px) {
        .mines-banner-section.headerElement {
            display: none;
        }
    }
</style>